import i18n from 'i18next';

// import { getTaggableContent } from '../helpers/getMockData';
import getTaggableContent from '../helpers/getTaggableContent';

export default () => ({
  content: {
    type: 'Select',
    label: i18n.t('tag-content'),
    help: i18n.t('tag-content-help'),
    isAsync: true,
    selectProps: {
      defaultOptions: true,
      hasEmptyOptionsMessage: true,
      isFluid: true,
      isFullWidth: true,
      isSearchable: true,
      loadingMessage: () => i18n.t('loading'),
      loadOptions: getTaggableContent,
      noOptionsMessage: () => i18n.t('no-matches'),
      placeholder: i18n.t('tag-content-placeholder'),
    },
    validators: [{ type: 'isRequired' }],
  },
});
